<!-- <pq-theme></pq-theme> -->
<setting-filter></setting-filter>
<pq-setting></pq-setting>
<pq-help *ngIf="!isAppPreview"></pq-help>
<kt-language-selector *ngIf="!isAppPreview"></kt-language-selector>
<user-profile></user-profile>
